import React from 'react';
import { Input, Button, PaperClip, Select } from 'components';
import { SpecialityService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';

interface Props {
	onClose?: any;
	item?: any;
}

class CreateSpeciality extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        photo: ''
		}
	}

	async componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || ''
				},
				item: this.props.item
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await SpecialityService.admin.edit({
				speciality_id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
			});
			Globals.showSuccess("Se ha modificado la especialidad correctamente");
			this.props.onClose();
		}
		else {
			if (!this.state.form.photo) {
				Globals.showError("Debe ingresar la foto de la especialidad");
				return;
			}

			await SpecialityService.admin.create({
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
			});
			Globals.showSuccess("Se ha creado la especialidad correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-speciality">
				<form onSubmit={ this.submit }>
					<div className="container-image">
						<PaperClip
							className="paperclip-image"
							value={ this.state.form.photo }
							width={ 450 }
							height={ 450 }
							size={ 500 }
							onChange={ (e: any) => {
								this.setState({
									form: {
										...this.state.form,
										photo: e.target
									}
								})
							} }>
							{/*
							// @ts-ignore */}
							<img className={ `selected-image ${ (this.state.form.photo || this.state.item?.photo) ? '' : 'inactive' }` } src={ this.state.form.photo?.dataURL || (this.state.item?.photo ? (Constants.BASE_STORAGE + this.state.item?.photo) : WhiteImage) } />
						</PaperClip>
						<p className="photo-title">Foto de la especialidad</p>
					</div>
					<p className="subtitle">La imagen debe ser formato JPG o PNG de 500kb, como máximo de 450px por 450px</p>
					<Input
						color="white"
						value={ this.state.form.name }
						name="name" 
						label="Nombre"
						onChange={ this.change } />
					<div className="row row-buttons">
						<div className="col-md-6 text-center">
							<Button type="button" onClick={ () => this.props.onClose() }>
								Cerrar
							</Button>
						</div>
						<div className="col-md-6 text-center">
							<Button type="submit">
								Guardar
							</Button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateSpeciality;